var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1Referral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    d: "M 8.71 161.855 L 8.71 131.837 L 126.605 131.837 L 126.605 161.855 L 8.71 161.855 Z M 8.71 101.821 L 8.71 71.805 L 185.553 71.805 L 185.553 101.821 L 8.71 101.821 Z M 8.71 41.788 L 8.71 11.772 L 185.553 11.772 L 185.553 41.788 L 8.71 41.788 Z M 200.289 236.895 L 200.289 116.83 L 288.71 176.862 L 200.289 236.895 Z",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1Referral);
export default __webpack_public_path__ + "static/media/s1-referral.75fb7d4699dc0ae3a1022b151cd7780c.svg";
export { ForwardRef as ReactComponent };